import { LocStoreInstance } from ".";
import { lp } from "../utils/logPrefix";
import { ITextAndTranslation } from "./ITextAndTranslation";

let alreadyWarnedMissingIds = false;
let alreadyWarnedMissingTranslations = false;

export const getTranslatedText = (
  inputText: string,
  searchWords: string[],
  stringContext: string,
  id: string,
  locStoreInstance: LocStoreInstance
) => {
  if (typeof inputText !== "string") {
    console.error(lp(), `String for translation must be of type string ${id}`);
  }

  if (inputText.startsWith(" ") || inputText.endsWith(" ")) {
    console.error(lp(), `Translation of padded string not supported ${id}`);
  }

  let TT: ITextAndTranslation;

  const translationsLoaded = !!locStoreInstance.gotTranslationsForLocale;

  if (translationsLoaded) {
    TT = locStoreInstance.getTranslation(id, inputText, stringContext);
  }

  const found = translationsLoaded && TT;
  const match = found && inputText === TT.text;

  const canUseTranslation = match && typeof TT.translated === "string";
  const canUseEnglishTranslation =
    match && typeof TT.englishTranslation === "string";

  let translatedText = inputText;
  if (canUseTranslation) {
    translatedText = TT.translated;
  } else if (canUseEnglishTranslation) {
    translatedText = TT.englishTranslation;
  }

  if (translationsLoaded && !found) {
    setTimeout(() => {
      const w: any = window;
      if (!w.missingLocalization) {
        w.missingLocalization = {};
      }
      if (!w.missingLocalization[stringContext]) {
        w.missingLocalization[stringContext] = {};
      }

      w.missingLocalization[stringContext][id] = inputText;

      if (!alreadyWarnedMissingIds) {
        console.warn(
          lp(),
          "Missing ids. Run npm run translate.",
          (window as any).missingLocalization
        );
        alreadyWarnedMissingIds = true;
      }
    });
  }

  if (translationsLoaded && found && !canUseTranslation) {
    setTimeout(() => {
      const w: any = window;
      if (!w.missingTranslation) {
        w.missingTranslation = {};
      }
      if (!w.missingTranslation[stringContext]) {
        w.missingTranslation[stringContext] = {};
      }

      w.missingTranslation[stringContext][id] = inputText;

      if (!alreadyWarnedMissingTranslations) {
        console.warn(
          lp(),
          "Missing translations Falling back to english where possible. To get rid of warning translate on crowdin and synchronize. window.missingTranslation:",
          (window as any).missingTranslation
        );
        alreadyWarnedMissingTranslations = true;
      }
    });
  }

  if (translationsLoaded && found && !match) {
    console.error(
      lp(),
      `Source for [${stringContext}]${id} does not match`,
      `InputText=${inputText}`,
      `Source=${TT.text}`
    );
  }

  if (!translationsLoaded) {
    return "";
  }

  const inputTextIsCapitalized =
    inputText.length > 0 && inputText[0] === inputText[0].toUpperCase();
  const translatedTextIsCapitalized =
    translatedText.length > 0 &&
    translatedText[0] === translatedText[0].toUpperCase();

  if (
    inputTextIsCapitalized &&
    !translatedTextIsCapitalized &&
    translatedText.length > 0
  ) {
    translatedText = translatedText[0].toUpperCase() + translatedText.slice(1);
  }

  return translatedText;
};
